import styled from "styled-components";
import {Layout} from "antd";

export const StyledFooter = styled(Layout.Footer)`
  padding: 12px 0;
  background: var(--c-line);
`